<template>
  <div class="index" @click="h5show = false">
    
    <div class="index-con">
      <div class="big-title">
        <span>Contact us</span>
      </div>
      School of Food Science and Technology,Jiangnan University,Wuxi, China
      <br />
      <br />
      <b>E-mail</b>: ids2024@jiangnan.edu.cn<br />
      <b>Website</b>: www.ids2024.com<br />

      <div class="bottom_span"></div>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d27220.845067105343!2d120.2628506!3d31.4800329!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b384344d95ebd5%3A0xbc3734bbf9b13ffd!2z5rGf5Y2X5aSn5a2m!5e0!3m2!1szh-CN!2sus!4v1701434680415!5m2!1szh-CN!2sus"
        width="100%"
        height="550"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>

      <div class="bottom_span"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.bottom_span {
  padding-top: 80px;
}
 
.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.navbg {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}   

@media screen and (max-width: 768px) { 
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .navbg {
    display: none;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue